import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, forwardRef, useContext, useMemo } from 'react';
import { Dropdown as HeadlessDropdown } from '@flywire/react-headlessui';
import { cx } from '../../utils/cx';
import { Button } from './Button';
import { Item } from './Item';
import { Items } from './Items';
const DropdownContext = createContext({});
export const useDropdownContext = () => {
    return useContext(DropdownContext);
};
export const useDropdownClasses = ({ className }) => {
    return cx('group relative inline-block', className);
};
const DropdownComponent = forwardRef(({ className, children, ...rest }, ref) => {
    const classes = useDropdownClasses({ className });
    const contextValue = useMemo(() => ({}), []);
    return (_jsx(DropdownContext.Provider, { value: contextValue, children: _jsx(HeadlessDropdown, { ref: ref, className: classes, ...rest, children: children }) }));
});
DropdownComponent.displayName = 'Dropdown';
const Dropdown = DropdownComponent;
Dropdown.Button = Button;
Dropdown.Item = Item;
Dropdown.Items = Items;
export { Dropdown };
//# sourceMappingURL=Dropdown.js.map